<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

<!--    사업장 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>사업장 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>작업내용(필수)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_1 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_1" />
        </div>
        <div>
          <div>조사일(필수)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_2 }} </span>
          <date-selector v-else :readonly="board.readonly" placeholder="날짜선택" v-model="form.inputA_2" />
        </div>
        <div>
          <div>작업자(필수)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_3 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_3" />
        </div>
      </div>
    </div>

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="유해·위험요인 분야"
      :tableData="[
        {
          id: 'cell1',
          title: '평가구분',
          type: 'select',
          selectData: valueTypeList,
          placeholder: '선택',
        },
        {
          id: 'cell2',
          title: projectId===2? '유해·위험요인(재해형태)':'유해·위험요인',
          type: 'customType',
          selectData: [],
          placeholder: '선택',
        },
        { id: 'cell3', title: '작업장소(공정)', type: 'text', placeholder: '내용' },
        { id: 'cell4', title: '위험작업내용', type: 'textarea', placeholder: '내용' },
      ]"
      :mobile="['cell1', 'cell2']"
      v-model="form.checkList"
    >
      <template #customType="{ trData, value, input }">
        <div v-if="isPrint">
          <span class="print-input">{{ trData.cell2 }}</span>
        </div>
        <div v-else>
          <ml-input v-if="!!trData && !!trData.cell1 && (!valueTypeList.includes(trData.cell1) || trData.cell1 === '기타')" class="w-full" v-model="trData.cell2" placeholder="직접입력"/>
          <vs-select v-else-if="!!trData && !!trData.cell1" class="w-full" autocomplete v-model="trData.cell2" :disabled="board.readonly">
            <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in handleAppraisalType(trData.cell1)" />
            <vs-select-item v-show="false" :value="trData.cell2" :text="trData.cell2" />
          </vs-select>
          <vs-select v-else class="w-full"></vs-select>
        </div>
      </template>
    </table-custom>

    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-28px" />
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import SearchNavStartEnd from "../../../../components/nav/SearchNavStartEnd.vue";
import FileUploadModule from "../../../modules/FileUploadModule.vue";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";
import {required} from "vuelidate/lib/validators";

export default {
  components: {
    PopupLoadPrevBoard,
    PhotoUploadGridModule,
    TableCustom,
    TimeSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    SearchNavStartEnd,
    FileUploadModule,
    FieldSelectModule,
  },
  validations: {
    form: {
      inputA_1: { required },
      inputA_2: { required },
      inputA_3: { required },
    },
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  mounted() {
    if (this.projectId === 2) {
      this.valueTypeList = [
        '기계적 요인',
        '전기적 요인',
        '화학적 요인',
        '생물학적 요인',
        '작업특성 요인',
        '작업환경 요인',
        '기타',
      ]
    }
  },
  data() {
    return {
      valueTypeList: [
        '기계(설비)적 요인',
        '전기적 요인',
        '화학(물질)적 요인',
        '생물학적 요인',
        '작업특성 요인',
        '작업환경 요인',
        '직접입력',
      ],
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",

        checkList: [],
        fileList: [],
      },
    };
  },
  methods: {
    handleAppraisalType(type) {
      if (this.projectId === 2) {
        if (type === "기계적 요인") {
          return ["추락(사람이 떨어짐)", "낙하(물건이 떨어짐)", "전도(사람‧물건의 넘어짐, 미끄러짐)", "비래(날아오는 물체에 맞음)", "붕괴(건물‧물체의 무너짐)", "협착(깔리거나 끼임)", "충돌(부딪힘)", "절단, 베임, 찔림"];
        } else if (type === "전기적 요인") {
          return ["감전/누전", "전기불꽃", "화재/폭발", "과열"];
        } else if (type === "화학적 요인") {
          return ["기체 : 가스, 증기 등", "액체 : 미스트, 에어로졸 등", "고체 : 흄, 분진 등"];
        } else if (type === "생물학적 요인") {
          return ["병원성 미생물, 바이러스", "유전자 변형물질", "동식물"];
        } else if (type === "작업특성 요인") {
          return ["소음, 진동", "종사자 실수", "이상압력 및 밀폐공간", "온도(고온, 저온)", "중량물취급", "반복작업", "불안정한 작업자세", "작업(조작)도구"];
        } else if (type === "작업환경 요인") {
          return ["이상기온(고온/한랭)", "조도(조명)", "작업공간 정리정돈", "이동통로", "주변종사자", "무리한 작업시간"];
        } else if (type !== "") {
          return ["직접입력"];
        }
      }
      else {
        if (type === "기계(설비)적 요인") {
          return ["끼임(감김)", "위험한 표면(절단, 베임, 긁힘)", "기계(설비)의 낙하, 비래, 전복, 붕괴, 전도 위험 부분", "충돌위험 부분", "넘어짐(미끄러짐, 걸림, 헛디딤)", "추락위험 부분(개구부 등)", "기타", "직접입력"];
        } else if (type === "전기적 요인") {
          return ["감전(안전전압초과)", "아크", "정전기", "화재 / 폭발 위험", "기타", "직접입력"];
        } else if (type === "화학(물질)적 요인") {
          return ["가스", "증기", "에어로졸·흄", "액체·미스트", "고체(분진)", "반응성 물질", "방사선", "화재 / 폭발 위험", "복사열 / 폭발과압", "기타", "직접입력"];
        } else if (type === "생물학적 요인") {
          return ["병원성 미생물, 바이러스에 의한 감염", "유전자 변형물질(GMO)", "알러지 및 미생물", "동물", "식물", "기타", "직접입력"];
        } else if (type === "작업특성 요인") {
          return ["소음", "초음파·초저주파음", "진동", "근로자 실수(휴먼에러)", "저압 또는 고압상태", "질식위험·산소결핍", "중량물 취급작업", "반복작업", "불안정한 작업자세", "작업(조작)도구", "기후 / 고온 / 한랭", "기타", "직접입력"];
        } else if (type === "작업환경 요인") {
          return ["기후 / 고온 / 한랭", "조명", "공간 및 이동통로", "주변 근로자", "작업시간", "조직 안전문화", "화상", "작업(조작) 도구", "기타", "직접입력"];
        } else if (type !== "") {
          return ["직접입력"];
        }
      }
    },
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.inputA_1.required) {
          alert("작업내용을 반드시 입력해야 합니다");
        } else if (!this.$v.form.inputA_2.required) {
          alert("조사일을 반드시 입력해야 합니다");
        } else if (!this.$v.form.inputA_3.required) {
          alert("작업자를 반드시 입력해야 합니다");
        }

        return false;
      } else {
        // 유효성 검사가 성공한 경우
        return true;
      }
    },
  },
};
</script>
